import ContentsTypes from "@shared/enums/contentsTypes";
import ContentsCustomTypes from "@project/enums/contentsCustomTypes.enum";
import ListWrapPreview from "@project/components/ListWrap/ListWrapPreview";
export const ListWrapItem = {
    label: "Element de liste",
    key: "items",
    type: ContentsCustomTypes.LIST_WRAP_ITEM,
    children: [
        {
            label: "Libelle",
            key: "label",
            type: ContentsTypes.INPUT,
            value: "",
        },
    ],
};
export const ListWrap = {
    label: "Liste de badges",
    type: ContentsCustomTypes.LIST_WRAP,
    Preview: ListWrapPreview,
    icon: "th-large",
    editionModal: true,
    editionModalPosition: "top",
    children: [
        {
            key: "dynamicList",
            type: ContentsTypes.DYNAMIC_LIST,
            value: "",
            children: [
                {
                    key: "contentType",
                    children: [ListWrapItem],
                    value: ContentsCustomTypes.LIST_WRAP_ITEM,
                },
            ],
        },
    ],
};
